import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { configureCore } from '@hk/core'
import { App } from './app/App'
import './styles.css'

/* @hk/core is shared with the handset, which has neither `import.meta.env` nor an
   origin of its own to be relative to. The host supplies both facts here, once, before
   anything can make a request. */
configureCore({
  apiBaseUrl: (import.meta.env['VITE_API_BASE'] as string | undefined) ?? '/api/v1',
  developmentUserId:
    (import.meta.env['VITE_DEV_USER_ID'] as string | undefined)
    ?? '00000000-0000-0000-0000-000000000000',
})

const client = new QueryClient({
  defaultOptions: {
    queries: {
      // A failed board fetch is retried twice and then reported. Retrying forever
      // hides an outage behind a spinner, which is the state a supervisor cannot act
      // on — they need to be told, so they can fall back to the radio.
      retry: 2,
      staleTime: 10_000,
      refetchOnWindowFocus: true,
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      <App />
    </QueryClientProvider>
  </StrictMode>,
)
